import React from "react";
import _ from "lodash";
import {message, Modal} from "antd";
import queryString from "query-string";
import {update, reset} from "../../viewmodel/swjwLoginViewModel";
import ClientSelectActions from "../other/ClientSelectActions";
import TokenService from "../../service/sso/TokenService";
import BusinessConstants from "../../constant/BusinessConstants";
import MainActions from "../swjwloginmain/SwjwLoginMainActions";
import HzwjwUserService from "../../service/noAuth/hzwjw/UserService";
import HzwjwService from "../../service/noAuth/HzwjwService";
import PltService from "../../service/noAuth/PltService";


const getDataContext = getState => getState().swjwLoginViewModel;

const init = () => {
    return async (dispatch, getState) => {
    };
};

const smsLogin = (values, navigate) => {
    return async (dispatch, getState) => {
        const res = await PltService.loginBySmsAsync({
            mobile: values.mobile,
            smsCode: values.smsCode,
        });
        if (res.success) {
            const user = _.first(res.data);
            const {token} = await TokenService.getTokenAsync({
                userId: user.id,
            });
            if (user.hospital.id === "ROOT") { // 卫建委 
                const url = new URL("cms/pc/swjwindex.html", location.origin);
                url.searchParams.set("sso_token", token);
                location.replace(url.toString());
            } else {
                const url = new URL("renyuan/pc/index.html", location.origin);
                location.replace(url.toString());
            }
        } else if (res.code === 11000) {
            Modal.confirm({
                content: "手机号未绑定账号，请先绑定账号",
                okText: "立即绑定",
                onOk: () => {
                    dispatch(update({
                        accountBindModalVisible: true,
                    }));
                },
            });
        } else if (res.code === 10001) {
            if (_.size(res.data) > 1) {
                dispatch(ClientSelectActions.update({
                    hospitals: res.data,
                }));
                dispatch(MainActions.update({
                    isClientSelect: true,
                    swjwLogin: false,
                }));
            } else {
                const user = _.first(res.data);
                const {token} = await TokenService.getTokenAsync({
                    userId: user.id,
                });
                if (user.hospital.id === "ROOT") { // 卫建委 
                    const url = new URL("cms/pc/swjwindex.html", location.origin);
                    url.searchParams.set("sso_token", token);
                    location.replace(url.toString());
                } else {
                    const url = new URL("renyuan/pc/index.html", location.origin);
                    location.replace(url.toString());
                }
            }
        }
    };
};

const bindAccount = (values) => {
    return async (dispatch, getState) => {
        const {idCardNo, userName, mobile, smsCode} = values;
        const res = await HzwjwService.bindMobileByIdCardAsync({
            mobile,
            smsCode,
            idCardNo,
            userName,
        });
        message.success("绑定成功");
        if (_.size(res) === 1) {
            const user = res[0];
            await HzwjwService.noLoginAsync({
                userId: user.id,
            });
            if (user.hospital.id === "ROOT") {
                const {token: ssoToken} = await TokenService.getTokenAsync({
                    userId: user.id,
                });
                const url = new URL("cms/pc/swjwindex.html", location.origin);
                /*   const url = new URL("http://192.168.17.105:6443/pc/swjwindex.html"); */

                url.searchParams.set("sso_token", ssoToken);
                location.replace(url.toString());
            } else {
                const url = new URL("renyuan/pc/index.html", location.origin);
                location.replace(url.toString());
            }
        } else {
            dispatch(ClientSelectActions.update({
                hospitals: res,
            }));
            dispatch(update({
                isClientSelect: true,
                swjwLogin: false,
            }));
        }
        dispatch(update({
            accountBindModalVisible: false,
        }));
    };
};


export default {
    update,
    reset,
    init,
    smsLogin,
    bindAccount,
};
